<div class="container">

<div class="d-flex justify-content-between">
<mat-form-field appearance="outline" >
  <mat-label>Centre</mat-label>
  <mat-select (selectionChange)="showData($event)">
    <mat-option *ngFor="let c of (centres$|async)" [value]="c.centreCode">{{c.centreName}}</mat-option>
    <mat-option value="All">All Centres</mat-option>
  </mat-select>
</mat-form-field>


  <mat-form-field appearance="outline">
    <mat-label>Select Month</mat-label>
    <mat-select (selectionChange)="onMonthChange($event)">
      <mat-option *ngFor="let month of months" [value]="month">{{ month }}</mat-option>
    </mat-select>
  </mat-form-field>

</div>
<!--  <div class="row">-->
<!--    <mat-form-field class="col-md-4">-->
<!--      <mat-label>Filter</mat-label>-->
<!--      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>-->
<!--    </mat-form-field>-->
<!--  </div>-->
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Birthday Report</h2>
      </li>
            <li class="dropdown m-l-20">
              <label for="search-input"><i class="material-icons search-icon">search</i></label>
              <input placeholder="Search" type="text" class="browser-default search-field"
                     (keyup)='applyFilter($event)' aria-label="Search box" #input>
            </li>
    </ul>
    <ul class="header-buttons mr-2">

      <!--        <li>-->
      <!--          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
      <!--            <img src="assets/images/icons/xlsx.png" alt="" />-->
      <!--          </div>-->
      <!--        </li>-->
    </ul>
  </div>


<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

    <!-- Diagnosis Column -->
    <ng-container matColumnDef="firstname"  >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
      <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
    </ng-container>

    <!-- Address Column -->
    <ng-container matColumnDef="lastname" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
      <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
    </ng-container>
    <!-- Address Column -->
    <ng-container matColumnDef="dobMonth" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Month </th>
      <td mat-cell *matCellDef="let element"> {{element.dobMonth}} </td>
    </ng-container>
    <ng-container matColumnDef="dobDate">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let element"> {{element.dobDate}} </td>
    </ng-container>





    <!-- Age Column -->
    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef> Age </th>
      <td mat-cell *matCellDef="let element"> {{element.age}} </td>
    </ng-container>

    <!-- date Column -->
    <ng-container matColumnDef="dob">
      <th mat-header-cell *matHeaderCellDef> Date of Birth </th>
      <td mat-cell *matCellDef="let element"> {{ element.dob.toDate() | date:"dd/MM/yyyy" }} </td>
    </ng-container>




    <!-- Centre Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre Name </th>
      <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
    </ng-container>

    <!-- Child Code Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef> State </th>
      <td mat-cell *matCellDef="let element"> {{element.state}} </td>
    </ng-container>

    <!-- City Column -->
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef> City </th>
      <td mat-cell *matCellDef="let element"> {{element.city}} </td>
    </ng-container>

    <!-- Use more ng-container elements to define other columns -->

    <!-- Table Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" aria-label="Select page of users"></mat-paginator>

</div>


</div>
